<template>
    <v-app>
        <v-main>
            <v-container>
                <v-row justify="center">
                    <v-col cols="3" class="text-center">
                        <h1>Dante6</h1>
                        <v-form @submit.prevent="login">
                            <v-card style="position:relative;">
                                <v-overlay :value="loading" absolute>
                                    <v-progress-circular
                                        indeterminate
                                        size="64"
                                    ></v-progress-circular>
                                </v-overlay>
                                <v-card-text>
                                    <v-alert color="error" dense outlined v-if="error">Ongeldige gebruikersnaam/wachtwoord</v-alert>
                                    <v-text-field prepend-icon="mdi-account" label="Gebruikersnaam" v-model="name"></v-text-field>
                                    <v-text-field type="password" prepend-icon="mdi-lock" label="Wachtwoord" v-model="password"></v-text-field>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" type="submit">Login</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-form>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
export default {
    name: "Login",
    data () {
        return {
            name: '',
            password: '',
            loading: false,
            error: false
        }
    },
    methods: {
        async login() {
            this.loading = true;
            this.error = false;
            try {
                await this.$store.dispatch('auth/login', {
                    name: this.name,
                    password: this.password
                });
                await this.$router.push('/');
            } catch(e) {
                console.log(e);
                //if (e.response.status === 422) {
                    //if (e.response.data.error) {
                    //    await this.$store.dispatch('message/showMessage', {text: e.response.data.error, color: 'error'});
                    //}
                //}
                this.error = true;
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>

<style scoped>

</style>
